<template>
  <div id="kioskfilter" style="width: max-content; position:relative; display:block; margin:auto;">

      <div style="font-size:16px;">
          <table style="padding-left:16px;">
          <tr style="display:flex;">
            <td style="width:140px;">
          <md-checkbox v-model="vorstieg">Vorstieg</md-checkbox>
            </td>
            <td>
              <md-checkbox v-model="isContest">Wettbewerb</md-checkbox>
            </td>
          </tr>
          <tr style="display:flex;">
            <td style="width:140px;">
              <md-checkbox v-model="toprope">Toprope</md-checkbox>
            </td>
            <td>
            <md-checkbox v-model="isNeuFilter">Neue Routen</md-checkbox>
            </td>
        </tr>
      </table>
      </div>

      <md-divider></md-divider>
      <div>
        <div style="display: flex; height: 48px; padding: 10px;">
          <span><md-rating-bar v-model="kioskRating" :md-icon-size="1" class="md-primary" :md-max-rating="5"></md-rating-bar></span>
          <span @click="resetRating()" style="padding-top:5px; cursor:pointer; font-size:16px; padding-left:8px;">Bewertung</span>
        </div>
        <md-divider></md-divider>
      </div>

      <div class="lowlevel">
        <input @change.prevent="disableMinRange" type="range" min=0 max=35 step=1 v-model="minor">
      </div>
      <div class="highlevel">
        <input @change.prevent="disableMinRange" type="range" min=2 max=36 step=1 v-model="major">
      </div>

    <!-- START FILTER DIFFICULTY IMAGE -->
      <div class="backdifficulty">
        <div class="masked">
          <img src="../../assets/kiosk_difficulties.svg" alt="Difficulties">
        </div>
        <div class="difficulty">
          <svg :width="342" height="172">
            <rect :width=highlevel :x=lowlevel y="0" height="145" style="fill:#00838f;"/>
          </svg>
        </div>
      </div>

      <div class="applyFil">
        <span style="display:block; ">
          <span class="md-title">{{ minor | gradeFilter }}&emsp;</span>
          <span class="md-title">bis&emsp;{{ major | gradeFilter }}</span>
        </span>

      </div>
      <md-divider style="margin-bottom:5px;"></md-divider>

      <div style="margin:8px auto; text-align:center">
        <md-button class="md-raised md-accent md-dense"
                  @click.native="filteringKiosk()">
          {{ filterApplyButton }}
        </md-button>
        <md-button style="color:#00838f !important;" class="md-raised md-dense"
                  @click.native="changePageLoading(true), resetFiltering()">
          {{ filterResetButton }}
        </md-button>

      </div>
    </div>

</template>

<script>
import { mapState } from 'vuex'
import { mapMutations } from 'vuex'

export default {
  name: 'kioskfilter',

  data () {
    return {
      stopSliding: false,
      minor: 8,
      major: 29,
      stopMinor: 8,
      stopMajor: 29,
      vorstieg: false,
      toprope:false,
      isContest: false,
      isNeuFilter: false,
      contestOp: 'Wettbewerb',
      kioskRating: 0,
      filterApplyButton: 'Filter anwenden',
      filterResetButton: 'Reset'
    }
  },

  mounted () {
    this.vorstieg = false
    this.toprope = false
    this.kioskRating = 0
    this.isContest = false
    this.isNeuFilter = false
    this.minor = this.defaultMinor
    this.major = this.defaultMajor
    this.stopMinor = this.defaultMinor
    this.stopMajor = this.defaultMajor
    this.$nextTick(() => {
      this.filteringKiosk()
    })

  },

  computed: {
    ...mapState([
      'defaultMinor',
      'defaultMajor',
      'sectorDetails',
      'isFilter',
      'updateKiosk',
      'storeList'
    ]),

    highlevel: function () {
      return Math.abs((this.major * 9 - this.minor * 9) + 9)
    },

    lowlevel: function () {
      return Math.abs((this.minor * 9) + 9 )
    },

    sectorId () {
      return this.$store.state.sectorDetails.id
    },
  },

  methods: {
    ...mapMutations([
      'changeButtonColor',
      'changeByRating',
      'changeByVorstieg',
      'changeByToprope',
      'changeByGrade',
      'changeByNew',
      'changeByContest',
      'changeResetKiosk',
      'changeUpdateKiosk',
      'changePageLoading',
      'changeMarkOpen'
    ]),

    filteringKiosk() {
      this.changeByVorstieg(this.vorstieg)
      this.changeByRating(this.kioskRating)
      this.changeByToprope(this.toprope)
      this.changeByContest(this.isContest)
      this.changeByNew(this.isNeuFilter)
      this.changeByGrade([this.minor,this.major])
      this.$emit("clearingPop")
    },

    resetFiltering() {
      this.changePageLoading(true)
      setTimeout(() => {
        this.vorstieg = false
        this.toprope = false
        this.kioskRating = 0
        this.isContest = false
        this.isNeuFilter = false
        this.minor = this.defaultMinor
        this.major = this.defaultMajor
        this.stopMinor = this.defaultMinor
        this.stopMajor = this.defaultMajor
        this.changeButtonColor('#00838f')
        this.changeByGrade(this.defaultMinor, this.defaultMajor)

        this.$nextTick(() => {
          this.filteringKiosk()
        })
        this.changeMarkOpen(false)
        this.changePageLoading(false)
      }, 1200)
    },

    resetRating() {
      this.kioskRating = 0
    },

    disableMinRange: function () {
      if ((this.major < this.minor) || (this.major > this.stopMajor) || (this.major < this.stopMinor)) {
        this.major = this.stopMajor
        this.minor = this.stopMinor
        this.changeButtonColor('#00838f')
      } else if ((this.minor > this.stopMajor) || (this.minor < this.stopMinor) || ((this.major - this.minor) <= -1)) {
        this.major = this.stopMajor
        this.minor = this.stopMinor
        this.changeButtonColor('#00838f')
      } else {
        this.changeButtonColor('#c51162')
        // console.log('Continue sliding')
      }
    }
  }
}

</script>

<style scope>

  #kioskfilter .levels {
    color:black;
    width:340px;
    text-align:center;
  }

  #kioskfilter .lowlevel {
    width:340px;
    z-index:10;
    display:block;
    position:relative;
    height:1px;
  }

  #kioskfilter .highlevel {
    width:340px;
    z-index:9;
    margin-left:20px;
    position:relative;
    height:1px;
  }

  #kioskfilter .backdifficulty {
    width:341px;
    position:relative;
    z-index:6;
    background:#cfd8dc;
  }

  #kioskfilter .difficulty {
    position:relative;
    z-index:7;
    width:342px;
    margin-top:-135px;
    max-height: 140px;
  }

  #kioskfilter .masked {
    position:relative;
    z-index:8;
    width:345px;
    /* margin-left: -1px; */
    height: 135px;
  }

  #kioskfilter input[type="range"] {
    display: block;
    width: 100%;
  }

  label {
    margin-left:0px;
  }

  #kioskfilter input[type=range] {
    -webkit-appearance: none;
    width: 100%;
    margin: 0 -1px;
  }

  #kioskfilter input[type=range]:focus {
    outline: none;
  }

  #kioskfilter input[type=range]::-webkit-slider-runnable-track {
    width: 100%;
    height: 1px;
    cursor: pointer;
    box-shadow: none;
    background: transparent;
    border-radius: 0px;
    border: none;
  }

  #kioskfilter input::-moz-focus-inner, #kioskfilter input::-moz-focus-outer {
    border: none;
  }

  #kioskfilter input[type=range]::-webkit-slider-thumb {
    box-shadow: none;
    border: none;
    height: 170px;
    width: 28px;
    border-radius: 0px;
    background: transparent url(../../assets/level_indicator.svg) no-repeat 0% 50%;
    cursor: pointer;
    -webkit-appearance: none;
    margin-top: 0px;
  }

  #kioskfilter input[type=range]:focus::-webkit-slider-runnable-track {
    background: transparent;
  }

  #kioskfilter input[type=range]::-moz-range-track {
    width: 100%;
    height: 0px;
    cursor: pointer;
    box-shadow: none;
    -moz-box-shadow: none;
    -webkit-box-shadow: none;
    background: transparent;
    border-radius: 0px;
    border: none;
  }

  #kioskfilter input[type=range]::-moz-range-thumb {
    box-shadow: none;
    -moz-box-shadow: none;
    -webkit-box-shadow: none;
    border: none;
    position:relative;
    z-index:20;
    margin-left:-12px;
    height: 357px;
    width: 26px;
    border-radius: 0px;
    background: transparent url(../../assets/level_indicator.svg) no-repeat 0% 100%;
    cursor: pointer;
  }

  #kioskfilter input[type=range]::-ms-track {
    width: 100%;
    height: 0px;
    cursor: pointer;
    background: transparent;
    border-color: transparent;
    color: transparent;
  }

  #kioskfilter input[type=range]::-ms-fill-lower {
    background: transparent;
    border: none;
    border-radius: 0px;
    box-shadow: none;
  }

  #kioskfilter input[type=range]::-ms-fill-upper {
    background: transparent;
    border: none;
    border-radius: 0px;
    box-shadow: none;
  }

  #kioskfilter input[type=range]::-ms-thumb {
    box-shadow: none;
    -moz-box-shadow: none;
    -webkit-box-shadow: none;
    border: none;
    height: 170px;
    margin-left:-12px;
    width: 28px;
    border-radius: 0px;
    background: transparent url(../../assets/level_indicator.svg) no-repeat 0% 50% !important;
    cursor: pointer;
  }

  #kioskfilter input[type=range]:focus::-ms-fill-lower {
    background: transparent;
  }

  #kioskfilter input[type=range]:focus::-ms-fill-upper {
    background: transparent;
  }

  #kioskfilter .md-theme-default a:not(.md-button)
    {text-decoration:none;
    color:#ffffff;
  }

  #kioskfilter .applyFil {
    /* max-width:360px; */
    height:46px;
    padding-top: 10px;
    margin: auto;
    text-align: center;
    position: relative;
    z-index: 12;
    display: block;
    background-color: #ffffff;
  }

</style>
